import type { ReactNode } from 'react';
import {
  FormField,
  FormFieldControl,
  FormFieldError,
  FormFieldHint,
  FormFieldLabel,
  FormFieldWarning,
  type FormFieldControlProps,
  type FormFieldErrorTone,
} from '@eureca/ui';

export interface FieldShellProps {
  name: string;
  label: string;
  required: boolean;
  hint?: string;
  error?: string;
  warning?: string;
  /**
   * Tom da mensagem de erro. Desde a reprova do QA (08/10/2026) TODO controle do
   * DS pinta a própria borda no erro (Figma 20080:1334), então o padrão é
   * `neutral` para todos; a prop fica para um caso que precise do contrário.
   */
  tone?: FormFieldErrorTone;
  children: FormFieldControlProps['children'];
  /** Tags e extras que ficam abaixo da dica. */
  after?: ReactNode;
}

/**
 * Grupos que o Figma desenha SEM o sufixo "(obrigatório)" no label (QA 08/10/2026:
 * 22657 "aceitar todos os cursos", 22645 "Tipo de deficiência"). A obrigatoriedade
 * continua: `aria-required` e a validação não mudam.
 */
const NO_REQUIRED_SUFFIX = new Set(['aceita_todos_cursos', 'tipo_deficiencia']);

/** Envelope único dos campos: obrigatoriedade, dica, aviso e erro (padrões do DEV-259). */
export function FieldShell({
  name,
  label,
  required,
  hint,
  error,
  warning,
  tone = 'neutral',
  children,
  after,
}: FieldShellProps) {
  return (
    <div data-question={name} data-testid={`field-${name}`}>
      <FormField
        error={!!error}
        warning={!!warning}
        required={required}
        requiredSuffix={!NO_REQUIRED_SUFFIX.has(name)}
        errorTone={tone}
      >
        <FormFieldLabel>{label}</FormFieldLabel>
        <FormFieldControl>{children}</FormFieldControl>
        <FormFieldHint>{hint}</FormFieldHint>
        <FormFieldWarning>{warning}</FormFieldWarning>
        <FormFieldError>{error}</FormFieldError>
        {after}
      </FormField>
    </div>
  );
}
